import React, { useState } from 'react';
import { Row, Container, Button, Alert } from 'reactstrap';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { partial } from '../../../util/translation/translation';
import renderField from '../../../shared/components/custom/Field';
import { connect } from 'react-redux';
import validateEmailInvite from './validateEmailInvite';
import { toast } from 'react-toastify';
import Api from '../../../util/api';
import Loading from '../../../shared/components/custom/Loading';

const EmailInviteModal = ({ formValues, event }) => {
  const p = partial('EventParticipantsPage');
  const s = partial('shared');

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        email: values.email,
        maxGuests: values.maxGuestAmount,
      };
      await Api.events.sendEmailInvite(event.id, payload);
      toast.success(p('emailInviteSuccess'));
    } catch (err) {
      toast.error(p('inviteNotSent'));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="form">
      <Loading loading={loading} />
      <Container>
        <Alert color="info">
          {p('guetsEmailMessageInformation')} {p('guetsMessageInformation')}
        </Alert>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group mx-2">
            <span className="form-header">{s('email')}</span>
            <Field
              name="email"
              placeholder={s('email')}
              component={renderField}
            />
          </div>
          <div className="form__form-group mx-2">
            <span className="form-header">{p('numberOfGuests')}</span>
            <Field
              name="maxGuestAmount"
              placeholder={p('chooseGuests')}
              disabled={!formValues?.email}
              component={renderField}
              type="number"
            />
          </div>
          <Button
            color="primary"
            type="button"
            disabled={loading}
            onClick={() => handleSubmit(formValues)}
          >
            {p('inviteParticipants')}
          </Button>
        </form>
      </Container>
    </div>
  );
};

const reduxF = reduxForm({
  form: 'EmailInviteModal',
  validate: validateEmailInvite,
});

const mapStateToProps = (state) => ({
  formValues: getFormValues('EmailInviteModal')(state),
});

export default connect(mapStateToProps)(reduxF(EmailInviteModal));
